// Navigation
$('#menu-toggle').click(function () {
    var $body = $('body'),
        $menu = $('.nav-container'),
        $hamburger = $('.hamburger');
    $body.toggleClass('menu-open')
    if ($body.hasClass('menu-open')) {
        $menu.addClass('menu-active');
        $hamburger.addClass('is-active');
    } else {
        $menu.removeClass('menu-active');
        $hamburger.removeClass('is-active');
    }
});

$(document).ready(function () {
    bindClickable();

    if ($('.banner-container').length) {
        watchBannerGlide();
    }

    if ($('.package-content-container').length) {
        grabPackage();
    }

    if ($('form.userform').length) {
        $('form.userform').find('.field.optionset').each(function () {
            watchForms($(this));
        })
    }
});

function watchForms($OptionSet) {
    let limit, numChecks = 0;
    let OptionSet = $OptionSet;

    $(OptionSet).each(function () {
        let classes = $(this)[0].classList;
        console.log($(this))

        $.each(classes, function(i, cls) {
            let match = cls.match(/^max-(\d+)$/);
            if (match) {
                limit = parseInt(match[1], 10);
            }
        });
    });

    console.log(OptionSet)

    if (limit !== 0) {
        $(OptionSet).find('.checkbox').each(function () {
            $(this).on('change', function () {
                if ($(this).prop('checked')) {
                    numChecks += 1;
                } else {
                    numChecks -= 1;
                }

                if (numChecks === limit) {
                    OptionSet.addClass('limit-reached');
                } else {
                    OptionSet.removeClass('limit-reached');
                }
            });
        });
    }
}

function grabPackage() {
    /* Package Ajax Requests */
    // $('.detailButtons, .detailImages').click(function (e) {
    //     e.preventDefault();
    //     var $myurl = $(this).attr('href'),
    //         $package = $(this).attr('id'),
    //         $container = $('.package-content-container')
    //
    //     $container.empty().addClass('loading');
    //
    //     $.ajax({
    //         url: $myurl,
    //         data: {package: $package}
    //     })
    //         .done(function (response) {
    //             var fullurl = window.location.protocol + "//" + window.location.host;
    //             window.history.pushState(null, null, fullurl + $myurl);
    //             $container.html(response).removeClass('loading')
    //
    //             var packageContainer = document.getElementById("overview");
    //             packageContainer.scrollIntoView();
    //         })
    //         .fail(function (xhr) {
    //             alert('Error: ' + xhr.responseText);
    //         });
    // });
}

function watchBannerGlide() {
    // Slider timing and animation
    var time = 1500,
        interval = 5000,
        slideSlider = function () {
            var $first = $('.homeSlider li').first().find('h1').animate({
                'margin-left': '-100vw'
            }, time)
            $('.homeSlider li').first().next().find('h1').css({
                'margin-left': '100vw'
            }).animate({
                'margin-left': 0
            }, time)
            $('.homeSlider').animate({left: '-100vw'}, time, function () {
                $('.homeSlider li').first().appendTo($('.homeSlider'))
                $('.homeSlider').css({left: 0})
                $first.css({
                    'margin-left': 0
                })
                queueNextSlide()
            })
        },
        queueNextSlide = function () {
            window.setTimeout(slideSlider, interval)
        }
    queueNextSlide()

    // let $glide = $('.banner-imgs-container');
    // let $mainGlide;
    //
    // $mainGlide = new Glide($glide[0], {
    //     type: "carousel",
    //     perView: 1,
    //     keyboard: false,
    //     animationDuration: 1200,
    //     swipeThreshold: false,
    //     dragThreshold: false,
    //     autoplay: 5000,
    //     gap: 0
    // });
    //
    // // Mount instance
    // window.setTimeout(function () {
    //     $mainGlide.mount();
    // }, 1000);
    //
    // // Update Glide for image resizing + take away loading cog
    // window.setTimeout(function () {
    //     $mainGlide.update();
    // }, 1250);
}

const bindClickable = () => {
    document.querySelectorAll(".clickable").forEach((card) => {
        const link = card.querySelector("a");

        if (link) {
            card.addEventListener("click", () => {
                link.click();
            });
            card.classList.add("ready");
        }
    });
};

document.querySelectorAll('select option').forEach(option => {
    if (/sold out/i.test(option.textContent)) {
        option.disabled = true;
        option.style.color = '#999'; // Optional: gray out the text
    }
});
